import React from "react";
import { NavLink, Link } from "react-router-dom/cjs/react-router-dom.min";
import {
  axiosContentDetail,
  axiosUserManagement,
  axiosNotification,
  axiosCmsAPI,
} from "../axios";
import axios from "axios";
import config from "../../config/config";
import { analytics } from "../analytics";
import ReactGA from "react-ga";
import { getContentWithLanguage } from "./language";
import { getEnv } from "../../helpers/env";
import { handleActionError } from "./error";
import { MetaContent } from "../constants/constant";
import cosmeticConfig from "../../config/cosmeticConfig";
import DOMPurify from 'isomorphic-dompurify';

const topicUrl = "/api/v1/topicAndChild";
const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// TODO this is turning a bit complicated, might want to split it out
export const IsEmpty = (val) => {
  if (val === false) {
    // Handles when a token == false is passed in
    return true;
  } else if (val === null || val === undefined) {
    return true;
  } else if (Array.isArray(val) || typeof val === "string") {
    return !val.length;
  } else if (typeof val === "object") {
    return !Object.keys(val).length;
  }
  return false;
};

export const isEmptyArray = (val) => Array.isArray(val) && val.length === 0;

export const assurePrefix = (url) => {
  return url.match(/^.{3,5}\:\/\//) ? url : `http://${url}`;
};

export const redirectionWrapper = (
  objectType,
  event,
  id,
  name,
  props,
  showLoader,
  hideLoader,
  language
) => {
  console.log("Redirect to:", objectType, language);

  switch (objectType) {
    case "series":
      redirectToSeriesUrl(event, id, name, props, showLoader, hideLoader);
      break;
    case "company":
      redirectToCompanyUrl(event, id, name, props, showLoader, hideLoader);
      break;
    case "topic":
      redirectToUrl(event, id, props, showLoader, hideLoader, language);
      break;
    case "expert":
      redirectToExpertUrl(event, id, name, props, showLoader, hideLoader);
      break;
    default:
      () => {};
      break;
  }
};

export const redirectToUrl = (
  event,
  id,
  props,
  showLoader = null,
  hideLoader = null,
  language
) => {
  if (event) {
    event.preventDefault();
  }
  if (showLoader) {
    showLoader();
  }

  axiosContentDetail
    .get(`${topicUrl}?id=${id}`)
    .then((response) => {
      const filteredByLanguage = getContentWithLanguage(
        response.data.data,
        language
      );
      if (hideLoader) {
        hideLoader();
      }
      props.history.push(
        `/topic${filteredByLanguage.topicDetails.tierInUrl}?topicID=${id}`
      );
    })
    .catch((error) => {
      handleActionError(
        "An error occurred getting topic-and-child data for redirection:",
        error
      );
    });
};

export const redirectToCompanyUrl = (
  event,
  id,
  name,
  props,
  showLoader,
  hideLoader
) => {
  if (event) {
    event.preventDefault();
  }
  if (showLoader) {
    showLoader();
  }
  let value = convertToSlug(name);
  if (hideLoader) {
    hideLoader();
  }
  props.history.push(`/company/${value}?companyID=${id}`);
};

export const redirectToExpertUrl = (
  event,
  id,
  name,
  props,
  showLoader,
  hideLoader
) => {
  if (event) {
    event.preventDefault();
  }
  if (showLoader) {
    showLoader();
  }
  let value = convertToSlug(name);
  if (hideLoader) {
    hideLoader();
  }
  props.history.push(`/expert/${value}?expertID=${id}`);
};

export const redirectToSeriesUrl = (
  event,
  id,
  name,
  props,
  showLoader,
  hideLoader
) => {
  if (event) {
    event.preventDefault();
  }
  if (showLoader) {
    showLoader();
  }
  let value = convertToSlug(name);
  if (hideLoader) {
    hideLoader();
  }
  props.history.push(`/series/${value}?seriesID=${id}`);
};

export const getAssociationUrlPrefix = (associationType) => {
  // console.log("Association type", associationType);
  let associationUrlPrefix = "";
  switch (associationType) {
    case "EVENT_SERIES":
      associationUrlPrefix = "series";
      break;
    case "series_driven":
      associationUrlPrefix = "series";
      break;
    case "COMPANY":
      associationUrlPrefix = "company";
      break;
    case "EXPERT":
      associationUrlPrefix = "expert";
      break;
    case "TAXONOMY":
      associationUrlPrefix = "topic";
      break;
    case "topic_driven":
      associationUrlPrefix = "topic";
      break;
    default:
      associationUrlPrefix = "topic";
      break;
  }
  return associationUrlPrefix;
};

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return results[2];
};

export const getLastInputFromUrl = (url) => {
  if (!url) url = window.location.href;
  let results = /[^/]*$/.exec(url)[0];
  if (!results) return null;
  return results;
};

export const objectToArray = (object) => {
  const formElementsArray = [];
  for (let key in object) {
    if (!object[key].noIteration) {
      formElementsArray.push({
        id: key,
        config: object[key],
      });
    }
  }
  return formElementsArray;
};

export const tConvert = (date) => {
  var d = new Date(date);
  var hh = d.getHours();
  var m = d.getMinutes();
  var s = d.getSeconds();
  var dd = "am";
  var h = hh;
  if (h >= 12) {
    h = hh - 12;
    dd = "pm";
  }
  if (h == 0 && dd == "pm") {
    h = 12;
  }
  m = m < 10 ? "0" + m : m;

  s = s < 10 ? "0" + s : s;

  //if you want 2 digit hours:
  h = h < 10 ? "0" + h : h;

  //var pattern = new RegExp("0?" + hh + ":" + m + ":" + s);

  var replacement = h + ":" + m;
  /* if you want to add seconds
  replacement += ":"+s;  */
  replacement += dd;

  return replacement;
};

export const getCurrentSlide = (array) => {
  let noProgramReturn = 0;
  let currentTime = Date.now();
  let currentSlideIndex = 0;
  // startDateTime endDateTime
  if (!IsEmpty(array)) {
    currentSlideIndex = array.findIndex((value, index) => {
      if (
        value.startDateTime <= currentTime &&
        value.endDateTime < currentTime
      ) {
        noProgramReturn = index;
      }
      if (
        value.startDateTime <= currentTime &&
        value.endDateTime > currentTime
      ) {
        return index;
      }
    });
  }
  return currentSlideIndex > 0 ? currentSlideIndex : noProgramReturn;
};

export const secondToTime = (time) => {
  var sec_num = parseInt(time, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return (hours != 0 ? hours + ":" : "") + minutes + ":" + seconds;
};

export const secondToJsonLd = (time) => {
  var sec_num = parseInt(time, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;
  let jsonLdTime = "";
  if (hours > 0) {
    jsonLdTime += hours + "H";
  }
  if (minutes > 0) {
    jsonLdTime += minutes + "M";
  }
  if (seconds > 0) {
    jsonLdTime += seconds + "S";
  }
  return "PT" + jsonLdTime;
};

export const returnDate = (date, showYear = true) => {
  const now = new Date();
  const uploadDate = new Date(date);
  const timeDiffMs = Math.abs(now - uploadDate);
  const minutes = Math.ceil(timeDiffMs / (1000 * 60));
  const hours = Math.ceil(minutes / 60);

  switch (true) {
    case minutes < 60:
      return minutes + " minutes ago";
    case hours >= 1 && hours <= 24:
      return hours + "h ago";
    case hours > 24:
      var format =
        uploadDate.getDate() + " " + monthNames[uploadDate.getMonth()];
      if (now.getFullYear() !== uploadDate.getFullYear() || showYear) {
        format += " " + uploadDate.getFullYear();
      }
      return format;
    default:
      break;
  }
  return timestamp;
};

export const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export const getRelativeTime = (time) => {
  switch (true) {
  }
};

export const returnFirstTier = (
  node,
  columbItem,
  liClass,
  headAnchorClass,
  ulClass,
  onTouchToggleActive,
  onMouseEnter,
  onMouseLeave,
  thisRef
) => {
  const activeNavMenu = document.getElementsByClassName("activeNav")[0];
  const elem = document.querySelectorAll(".tier1NavMenu");
  [].forEach.call(elem, function (el) {
    el.classList.remove("tier1NavMenu");
  });
  activeNavMenu && activeNavMenu.parentNode.classList.add("tier1NavMenu");
  return (
    node &&
    node.map((value, index) => {
      return (
        <li
          className={liClass}
          key={index}
          {...(!IsEmpty(onMouseEnter)
            ? { onMouseEnter: (event) => onMouseEnter(event) }
            : {})}
          {...(!IsEmpty(onMouseEnter)
            ? { onMouseLeave: (event) => onMouseLeave(event) }
            : {})}
        >
          {headAnchorClass == "vertical-menu" ? (
            <React.Fragment>
              <div className="verticalDiv">
                <span
                  className="aus"
                  {...(!IsEmpty(onTouchToggleActive)
                    ? { onClick: (event) => onTouchToggleActive(event) }
                    : {})}
                >
                  <Link
                    to={{
                      pathname: `/topic${value.tierInUrl}?topicID=${value.id}`,
                      state: {
                        navHeaderTitle: value.name,
                      },
                    }}
                    className={headAnchorClass}
                    onClick={(e) => thisRef.closeModal(e)}
                  >
                    {IsEmpty(value.navLabel) ? value.name : value.navLabel}
                  </Link>
                </span>
                {!IsEmpty(value.firstChildList) && (
                  <ul className={ulClass}>
                    {secondTier(value.firstChildList, columbItem, thisRef)}
                  </ul>
                )}
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <NavLink
                activeClassName="activeNav"
                to={{
                  pathname: `/topic${value.tierInUrl}?topicID=${value.id}`,
                  state: {
                    navHeaderTitle: value.name,
                  },
                }}
                className={headAnchorClass}
              >
                {IsEmpty(value.navLabel) ? value.name : value.navLabel}
              </NavLink>
              {!IsEmpty(value.firstChildList) && (
                <ul className={ulClass}>
                  {secondTier(value.firstChildList, columbItem, thisRef)}
                </ul>
              )}
            </React.Fragment>
          )}
        </li>
      );
    })
  );
};

export const secondTier = (node, items, thisRef = null) => {
  let returnHtml = [];
  const arrayMath = [...Array(Math.ceil(node.length / items)).keys()];
  returnHtml = arrayMath.map((value, index) => {
    let end =
      node.length > index * items + items ? index * items + items : node.length;
    return (
      <ul key={value + index}>
        {node.slice(index * items, end).map((value, index) => {
          return (
            <li key={value + index}>
              <Link
                to={{
                  pathname: `/topic${value.tierInUrl}?topicID=${value.id}`,
                  state: {
                    navHeaderTitle: value.name,
                  },
                }}
                onClick={thisRef ? thisRef.closeModal : () => {}}
              >
                {IsEmpty(value.navLabel) ? value.name : value.navLabel}
              </Link>
            </li>
          );
        })}
      </ul>
    );
  });
  return returnHtml;
};

export const seriesHeader = (node, items, thisRef = null) => {
  let returnHtml = [];
  const arrayMath = [...Array(Math.ceil(node.length / items)).keys()];
  returnHtml = arrayMath.map((value, index) => {
    let end =
      node.length > index * items + items ? index * items + items : node.length;
    return (
      <ul key={value + index}>
        {node.slice(index * items, end).map((series, seriesIndex) => {
          return (
            <li key={`seriesHeader-${seriesIndex}`}>
              <Link
                to={{
                  pathname: `/series/${convertToSlug(series.name)}?seriesID=${
                    series.id
                  }`,
                }}
                onClick={thisRef ? thisRef.closeModal : () => {}}
              >
                {series.name}
              </Link>
            </li>
          );
        })}
      </ul>
    );
  });
  return returnHtml;
};

export const convertToSlug = (url) => {
  return url
    .toLowerCase()
    .replace(/[^\w ]+/g, "")
    .replace(/ +/g, "-");
};

export const convertSlugToTitle = (slug) => {
  let words = slug.split("-");
  for (let i = 0; i < words.length; i++) {
    let word = words[i];
    words[i] = word.charAt(0).toUpperCase() + word.slice(1);
  }
  return words.join(" ");
};

export const epgSlide = (slidenumber, epgData) => {
  return (
    slidenumber >= 0 &&
    !IsEmpty(epgData.today) &&
    epgData.today[slidenumber].startDateTime <= Date.now() &&
    epgData.today[slidenumber].endDateTime > Date.now()
  );
};

export const checkLiveStream = (token) =>
  IsEmpty(token) &&
  typeof Storage !== "undefined" &&
  !IsEmpty(localStorage.getItem("liveStreamOverlay")) &&
  localStorage.getItem("liveStreamOverlay").split("-")[0] == "true" &&
  new Date(
    parseInt(localStorage.getItem("liveStreamOverlay").split("-")[1])
  ).getDate() == new Date().getDate()
    ? false
    : true;

export const getPlayingVideo = (railData, videoId) => {
  return railData.find((element) => element.id == videoId);
};

export const appleSignInAuth = () => {
  AppleID.auth.init({
    clientId: config.appleSignIn.client_id,
    scope: config.appleSignIn.scope,
    redirectURI: config.appleSignIn.redirect_uri,
  });
};

export const reformatDate = (dateStr) => {
  // 2021-29-06 (i/p) ===> JUN 29, 2021 (o/p)
  if (dateStr) {
    var dArr = dateStr.split("-");
    var month = parseInt(dArr[2]) - 1;
    var validDate = new Date(dArr[0], month, dArr[1]);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let finalFormattedDate =
      months[validDate.getMonth()] +
      " " +
      validDate.getDate() +
      ", " +
      validDate.getFullYear();
    return finalFormattedDate;
  } else {
    return "";
  }
};

export const reformatTime = (timeStr) => {
  // 1624906800000 ====> 00:30
  if (timeStr) {
    var date = new Date(timeStr);
    let options = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    };
    return date.toLocaleTimeString(undefined, options);
  } else {
    return "";
  }
};

export const checkFollowStatusById = (
  callback,
  userJwt = null,
  companyId = null,
  topicId = null,
  expertId = null
) => {
  // if a user follows a particular company,topic,expert
  if (userJwt) {
    // if user is loggedIn
    const config = {
      headers: {
        token: userJwt,
      },
    };
    let apiEndpoint = "";
    let objectId = "";
    if (companyId) {
      apiEndpoint = "/subscriber/follow/companies";
      objectId = companyId;
    } else if (topicId) {
      apiEndpoint = "/subscriber/follow/topics";
      objectId = topicId;
    } else if (expertId) {
      apiEndpoint = "/subscriber/follow/experts";
      objectId = expertId;
    } else {
      return false;
    }
    axiosUserManagement
      .get(apiEndpoint, { ...config })
      .then((res) => {
        res &&
          Object.values(res?.data?.userPreferenceDTOS).map((values) => {
            if (values?.id == objectId) {
              callback && callback(res, null);
              return true;
            }
          });
      })
      .catch((err) => {
        callback && callback(null, err);
        console.log(err);
      });
  } else {
    // if user is not loggedIn
    return false;
  }
};

export const fetchSearchResult = (
  callback,
  language,
  userJwt = null,
  list = [],
  searchString = "",
  objectType,
  offset = 0,
  max = 10
) => {
  let apiEndpoint = "/pub/api/v1/search";
  let object = "";
  if (objectType == "company") {
    object = "COMPANY";
  } else if (objectType == "topic") {
    object = "TAXONOMY";
  } else if (objectType == "expert") {
    object = "EXPERT";
  } else if (objectType == "series") {
    object = "EVENT_SERIES";
  } else if (objectType == "event") {
    object = "EVENT";
  } else {
    return list;
  }

  const reqBody = {
    token: userJwt,
    offset: offset,
    max: max,
    searchString: searchString,
    type: object,
    language: language,
  };

  axiosContentDetail
    .post(apiEndpoint, reqBody)
    .then((res) => {
      if (res && res?.data?.data.length > 0) {
        const filteredByLanguage = getContentWithLanguage(
          res.data.data,
          language
        );
        Object.values(filteredByLanguage).map((values) => {
          list.push(values);
        });
      }
      callback && callback(list, null);
    })
    .catch((err) => {
      callback && callback(null, err);
      handleActionError(
        "An error occurred while attempting to retrieve non-VOD search data:",
        err
      );
    });
};

export const getFollowedObjects = (
  callback,
  language,
  userJwt = null,
  list = [],
  isCompanyList = false,
  isTopicList = false,
  isExpertList = false,
  isSeriesList = false
) => {
  // append user follow status with array
  if (userJwt) {
    // if user is loggedIn
    const config = {
      headers: {
        token: userJwt,
      },
    };
    let apiEndpoint = "";
    let object = "";
    if (isCompanyList) {
      apiEndpoint = "/subscriber/follow/companies";
      object = "company";
    } else if (isTopicList) {
      apiEndpoint = "/subscriber/follow/topics";
      object = "topic";
    } else if (isExpertList) {
      apiEndpoint = "/subscriber/follow/experts";
      object = "expert";
    } else if (isSeriesList) {
      apiEndpoint = "/subscriber/follow/event/series";
      object = "series";
    } else {
      return list;
    }
    axiosUserManagement
      .get(apiEndpoint, { ...config })
      .then((res) => {
        res = getContentWithLanguage(res, language);
        if (res && res?.data?.userPreferenceDTOS.length > 0) {
          Object.values(res?.data?.userPreferenceDTOS).map((values) => {
            list.push(values);
          });
        }
        callback && callback(list, null);
      })
      .catch((err) => {
        callback && callback(null, err);
        handleActionError(
          "An error occurred while attempting to retrieve subscriber follow data:",
          err
        );
      });
  } else {
    // if user is not loggedIn
    return false;
  }
};

export const getRecoObjectsNew = (
  callback,
  language,
  userJwt = null,
  list = [],
  type = "",
) => {
  // fetch follow reco

  let apiEndpoint = "";
  let object = "";
  let count = 5;
  if (userJwt) {
    // if user is loggedIn
    switch (type) {
      case "company":
        apiEndpoint = "/api/v2/recommended/company";
        object = "company";
        break;
      case "topic":
        apiEndpoint = "/api/v2/recommended/topics";
        object = "topic";
        count = cosmeticConfig.reco_object_on_onboarding.MAX_TOPIC;
        break;
      case "expert":
        apiEndpoint = "/api/v2/recommended/expert";
        object = "expert";
        count = cosmeticConfig.reco_object_on_onboarding.MAX_EXPERT;
        break;
      case "series": 
        apiEndpoint = "/api/v2/recommended/event/series";
        object = "series";
        count = cosmeticConfig.reco_object_on_onboarding.MAX_SERIES;
        break;
      default:
        break;
    }

    // console.log("Fetching reco object for: " + object);

    let reqBody = {
      token: userJwt,
      max: count,
    };

    axiosContentDetail
      .post(apiEndpoint, reqBody)
      .then((res) => {
        res = getContentWithLanguage(res, language);

        if (res && res?.data?.data?.length > 0) {
          Object.values(res?.data?.data).map((values) => {
            list.push(values);
          });
        }
        callback && callback(list, null);
        // console.log('list', list)
        // return list;
      })
      .catch((err) => {
        // callback && callback(null, err);
        handleActionError(
          "An error occurred while attempting to retrieve recommended objects",
          err
        );
      });
  } else {
    // if user is not loggedIn
    return false;
  }
};

export const getRecoObjects = (
  callback,
  language,
  userJwt = null,
  list = [],
  count = 5,
  isCompanyList = false,
  isTopicList = false,
  isExpertList = false,
  isSeriesList = false
) => {
  // fetch follow reco
  if (userJwt) {
    // if user is loggedIn
    let apiEndpoint = "";
    let object = "";
    if (isCompanyList) {
      apiEndpoint = "/api/v2/recommended/company";
      object = "company";
    } else if (isTopicList) {
      apiEndpoint = "/api/v2/recommended/topics";
      object = "topic";
    } else if (isExpertList) {
      apiEndpoint = "/api/v2/recommended/expert";
      object = "expert";
    } else if (isSeriesList) {
      apiEndpoint = "/api/v2/recommended/event/series";
      object = "series";
    } else {
      return list;
    }

    // console.log("Fetching reco object for: " + object);

    let reqBody = {
      token: userJwt,
      max: count,
    };

    axiosContentDetail
      .post(apiEndpoint, reqBody)
      .then((res) => {
        res = getContentWithLanguage(res, language);

        if (res && res?.data?.data?.length > 0) {
          Object.values(res?.data?.data).map((values) => {
            list.push(values);
          });
        }
        callback && callback(list, null);
      })
      .catch((err) => {
        callback && callback(null, err);
        handleActionError(
          "An error occurred while attempting to retrieve recommended objects",
          err
        );
      });
  } else {
    // if user is not loggedIn
    return false;
  }
};

export const appendFollowStatus = (
  callback,
  userJwt = null,
  list = [],
  isCompanyList = false,
  isTopicList = false,
  isExpertList = false,
  isSeriesList = false
) => {
  // append user follow status with array
  if (userJwt) {
    // if user is loggedIn
    const config = {
      headers: {
        token: userJwt,
      },
    };
    let apiEndpoint = "";
    let object = "";
    if (isCompanyList) {
      apiEndpoint = "/subscriber/follow/companies";
      object = "company";
    } else if (isTopicList) {
      apiEndpoint = "/subscriber/follow/topics";
      object = "topic";
    } else if (isExpertList) {
      apiEndpoint = "/subscriber/follow/experts";
      object = "expert";
    } else if (isSeriesList) {
      apiEndpoint = "/subscriber/follow/event/series";
      object = "series";
    } else {
      return list;
    }
    axiosUserManagement
      .get(apiEndpoint, { ...config })
      .then((res) => {
        if (Array.isArray(list) && list.length > 0) {
          // if list is Array
          list.map((items, index) => {
            items.isFollowed = false;
            if (res && res?.data?.userPreferenceDTOS.length > 0) {
              Object.values(res?.data?.userPreferenceDTOS).map((values) => {
                if (values?.id == items.id) {
                  items.isFollowed = true;
                }
              });
            } else {
              items.isFollowed = false;
            }
            items.object = object;
          });
        } else if (typeof list === "object") {
          // if list is Object
          list.isFollowed = false;
          if (res && res?.data?.userPreferenceDTOS.length > 0) {
            Object.values(res?.data?.userPreferenceDTOS).map((values) => {
              if (values?.id == list.id) {
                list.isFollowed = true;
              }
            });
          } else {
            list.isFollowed = false;
          }
          list.object = object;
        }
        callback && callback(list, null);
      })
      .catch((err) => {
        callback && callback(null, err);
        handleActionError(
          "An error occurred while attempting to fetch subscriber follow data:",
          err
        );
      });
  } else {
    // if user is not loggedIn
    return false;
  }
};

export const followButtonClickedNew = (
  userJwt = null,
  objectId,
  objectType,
) => {
  // if a user follows a particular company,topic,expert
  if (userJwt) {
    // if user is loggedIn
    const config = {
      headers: {
        "content-type": "application/json",
        token: userJwt,
      },
    };
    let apiEndpoint = "";
    switch (objectType) {
      case "company":
        apiEndpoint = `/subscriber/add/follow/company/${companyId}`;
        break
      case "topic":
        apiEndpoint = `/subscriber/add/follow/topic/${topicId}`;
        break;
      case "expert":
        apiEndpoint = `/subscriber/add/follow/expert/${expertId}`;
        break;
      case "series":
        apiEndpoint = `/subscriber/add/follow/event/series/${seriesId}`;
        break;
      default: 
        break;
    }
    let reqBody = {};
    axiosUserManagement
      .post(apiEndpoint, reqBody, { ...config })
      .then((res) => {
        console.log("Res from follow button clicked", res);
        res.objectId = objectId;
        res.objectType = objectType;
        callback && callback(res, null);
        return res;
      })
      .catch((err) => {
        handleActionError(
          "An error occurred while attempting to follow an entity:",
          err
        );
        // callback && callback(null, err);
      });
  } else {
    // if user is not loggedIn
    return false;
  }
};

export const followButtonClicked = (
  callback,
  userJwt = null,
  companyId = null,
  topicId = null,
  expertId = null,
  seriesId = null
) => {
  // if a user follows a particular company,topic,expert
  if (userJwt) {
    // if user is loggedIn
    const config = {
      headers: {
        "content-type": "application/json",
        token: userJwt,
      },
    };
    let apiEndpoint = "";
    let objectType = "";
    let objectId = "";
    if (companyId) {
      apiEndpoint = `/subscriber/add/follow/company/${companyId}`;
      objectType = "company";
      objectId = companyId;
    } else if (topicId) {
      apiEndpoint = `/subscriber/add/follow/topic/${topicId}`;
      objectType = "topic";
      objectId = topicId;
    } else if (expertId) {
      apiEndpoint = `/subscriber/add/follow/expert/${expertId}`;
      objectType = "expert";
      objectId = expertId;
    } else if (seriesId) {
      apiEndpoint = `/subscriber/add/follow/event/series/${seriesId}`;
      objectType = "series";
      objectId = seriesId;
    } else {
      return false;
    }
    let reqBody = {};
    console.log("Object ID", objectId);
    axiosUserManagement
      .post(apiEndpoint, reqBody, { ...config })
      .then((res) => {
        console.log("Res from follow button clicked", res);
        res.objectId = objectId;
        res.objectType = objectType;
        callback && callback(res, null);
        return true;
      })
      .catch((err) => {
        handleActionError(
          "An error occurred while attempting to follow an entity:",
          err
        );
        callback && callback(null, err);
      });
  } else {
    // if user is not loggedIn
    return false;
  }
};

export const finalizeOnboarding = (userJwt) => {
  if(userJwt) {
    const config = {
      headers: {
        "content-type": "application/json",
        userToken: userJwt,
      },
    };
    const apiEndpoint = '/users/contact';
    let reqBody = {};
    axiosCmsAPI
      .post(apiEndpoint, reqBody, { ...config })
      .then(() => {
        return;
      })
      .catch((err) => {
        handleActionError(
          "An error occurred while attempting finalize onboarding:",
          err
        );
      });
  }
}

export const unFollowButtonClickedNew = (
  userJwt = null,
  objectId,
  objectType,
) => {
  // if a user unfollows a particular company,topic,expert
  if (userJwt) {
    // if user is loggedIn
    const config = {
      headers: {
        token: userJwt,
      },
    };
    let apiEndpoint = "";
    switch (objectType) {
      case "company":
        apiEndpoint = `/subscriber/delete/follow/company/${companyId}`;
        break
      case "topic":
        apiEndpoint = `/subscriber/delete/follow/topic/${topicId}`;
        break;
      case "expert":
        apiEndpoint = `/subscriber/delete/follow/expert/${expertId}`;
        break;
      case "series":
        apiEndpoint = `/subscriber/delete/follow/event/series/${seriesId}`;
        break;
      default: 
        break;
    }
    
    axiosUserManagement
      .delete(apiEndpoint, { ...config })
      .then((res) => {
        res.objectId = objectId;
        res.objectType = objectType;
        // callback && callback(res, null);
        return res;
      })
      .catch((err) => {
        // callback && callback(null, err);
        handleActionError(
          "An error occurred while attempting to unfollow an entity",
          err
        );
      });
  } else {
    // if user is not loggedIn
    return false;
  }
};
export const unFollowButtonClicked = (
  callback,
  userJwt = null,
  companyId = null,
  topicId = null,
  expertId = null,
  seriesId = null
) => {
  // if a user unfollows a particular company,topic,expert
  if (userJwt) {
    // if user is loggedIn
    const config = {
      headers: {
        token: userJwt,
      },
    };
    let apiEndpoint = "";
    let objectType = "";
    let objectId = "";
    if (companyId) {
      apiEndpoint = `/subscriber/delete/follow/company/${companyId}`;
      objectType = "company";
      objectId = companyId;
    } else if (topicId) {
      apiEndpoint = `/subscriber/delete/follow/topic/${topicId}`;
      objectType = "topic";
      objectId = topicId;
    } else if (expertId) {
      apiEndpoint = `/subscriber/delete/follow/expert/${expertId}`;
      objectType = "expert";
      objectId = expertId;
    } else if (seriesId) {
      apiEndpoint = `/subscriber/delete/follow/event/series/${seriesId}`;
      objectType = "series";
      objectId = seriesId;
    } else {
      return false;
    }
    axiosUserManagement
      .delete(apiEndpoint, { ...config })
      .then((res) => {
        res.objectId = objectId;
        res.objectType = objectType;
        callback && callback(res, null);
        return true;
      })
      .catch((err) => {
        callback && callback(null, err);
        handleActionError(
          "An error occurred while attempting to unfollow an entity",
          err
        );
      });
  } else {
    // if user is not loggedIn
    return false;
  }
};

export const sparkLoopReferralHandler = (
  RH_REFLINK,
  jwtToken = "",
  userEmail = ""
) => {
  const axiosSparkManagement = axios.create({
    baseURL: "https://api.sparkloop.app/v1/campaigns/MF7c4c83e64c/subscribers",
  });
  let config = {
    headers: {
      "content-type": "application/json",
      "x-api-key": "1167ccadcfcd94a965319de9",
    },
  };
  let reqBody = {
    email: userEmail,
    referrer_code: RH_REFLINK,
  };
  axiosSparkManagement
    .post("/", reqBody, { ...config })
    .then((res) => {
      console.log(res);
      if (res.status == 200) {
        backendReferralHandler(RH_REFLINK, jwtToken, userEmail);
        localStorage.removeItem("RH_REFLINK");
        localStorage.removeItem("isOldUser");
      }
    })
    .catch((err) => {
      handleActionError(
        "An error occurred while attempting to register a Sparkloop referral",
        err
      );
      localStorage.removeItem("RH_REFLINK");
      localStorage.removeItem("isOldUser");
    });
};

export const backendReferralHandler = (
  RH_REFLINK,
  jwtToken = "",
  userEmail = ""
) => {
  let config = {
    headers: {
      "cache-control": "no-cache",
      "content-type": "application/json",
      accept: "*/*",
      token: jwtToken,
      email: userEmail,
    },
  };
  let reqBody = {};
  axiosUserManagement
    .post("/subscriber/referral/" + RH_REFLINK, reqBody, { ...config })
    .then((res) => {
      if (res.status == 200) {
        console.log("referral saved in DB");
      }
    })
    .catch((err) => {
      handleActionError(
        "An error occurred while attempting to register a subscriber referral:",
        err
      );
    });
};

export const removefirebaseSignupEventCookie = () => {
  localStorage.removeItem("firebaseSignupEvent");
};

export const signUpAnalytics = () => {
  analytics("page_view", {
    page_title: "complete",
    page_location: `${getEnv("BASE_URL")}/signup/complete`,
    page_path: `${getEnv("BASE_URL")}/signup/complete`,
  });
  ReactGA.initialize(getEnv("GA_ID"));
  ReactGA.pageview("/signup/complete");
  let firebaseSignupEvent = localStorage.getItem("firebaseSignupEvent");
  analytics(firebaseSignupEvent, {
    event_callback: removefirebaseSignupEventCookie,
  });
};

export const fetchNotification = (callback, jwtToken) => {
  setTimeout(()=>{
    axiosNotification
    .get(`/notifications?category=${getEnv("BEAMER_CATEGORY")}&userId=${beamer_config.user_id}`)
    .then(res => {
      if (!IsEmpty(res.data)) {
        callback && callback(res.data, null);
      } else {
        callback && callback([], null);
      }
    })
    .catch(err => {
      handleActionError("An error occurred while attempting to retrieve Beamer notifications", err);
      return [];
    });
  }, 2000)
};

export const markAsReadNotification = (notificationId) => {
  axiosNotification
    .put(`/notifications/${notificationId}/read/${beamer_config.user_id}`)
    .then((_) => {
      console.log("marked as read");
    })
    .catch((err) => {
      handleActionError(
        "An error occurred while attempting to mark a notification as read:",
        err
      );
    });
};

export const isThisNotificationForMe = (callback, jwtToken, notification) => {
  let config = {
    headers: {
      "cache-control": "no-cache",
      "content-type": "application/json",
      token: jwtToken,
    },
  };
  axiosUserManagement
    .get(`subscriber/notification/notification/filter/${notification.id}`, {
      ...config,
    })
    .then((res) => {
      if (!IsEmpty(res.data?.data)) {
        res.data.data.notification = notification;
        callback && callback(res.data.data, null);
      } else {
        callback && callback(false, null);
      }
    })
    .catch((err) => {
      handleActionError(
        "An error occurred while attempting to determine if a notification is for the subscriber:",
        err
      );
      return [];
    });
};

export const getSeriesDescHtml = (htmlDesc, textDesc) => {
  let seriesDesc = "";
  if (!IsEmpty(htmlDesc)) {
    seriesDesc = htmlDesc;
  } else {
    seriesDesc = textDesc;
  }
  return {
    __html: seriesDesc,
  };
};

export const escapeDoubleQuotes = (inputString) => {
  if(inputString === null || inputString === undefined || !inputString) return "";
  return inputString.toString().replace(/"/g, '\\"');
};

export const generateStructuredData = (contentArr) => {
  if(contentArr && contentArr.length > 0 ) {
    const structuredData = contentArr.map((item) => {
      
      let about = item?.secondaryTopics?.length > 0 ? item?.secondaryTopics?.map((topic) => {
        return `{
          "@id": "${getEnv("BASE_URL")}/topic/${topic.name}/${topic.id}",
          "name": "${topic.name}" 
        }`
      }) : '';

      let experts = item?.experts?.length > 0 ? item?.experts?.map(expert => {
        return ` {
          "@type": "Person",
          "name": "${expert.name}",
          "url": "${getEnv("BASE_URL")}/expert/${convertToSlug(expert.name)}?expertID=${expert.id}"
        }`
      }) : '';

      return (
        `{
          "@type": "VideoObject",
          "@id": "${getEnv("BASE_URL")}/media/${convertToSlug(item.title)}?videoId=${item.id}",
          "name": "${item?.title ? escapeDoubleQuotes(item?.title) : ""}",
          "description": "${escapeDoubleQuotes(item?.desc ? item?.desc : item?.subtitle)}",
          "thumbnailUrl": "${item.imageUrl}",
          "uploadDate": "${new Date(item.publish_date).toISOString()}",
          "duration": "${secondToJsonLd(item.duration)}",
          "regionsAllowed": "AU",
          "contentUrl": "${item.videoUrl?.progressive ? item.videoUrl.progressive : ""}",
          "publisher":{
            "@type":"NewsMediaOrganization",
            "name":"ausbiz",
            "description": "${MetaContent.home.description}",
            "logo":"https://images.squarespace-cdn.com/content/v1/5e5091548bf5a551ea5d9dea/1582338795914-L4KPLRPXI13617OWE4T9/Logo%26Mark_White_Transparent%401x+%281%29.png",
            "foundingDate":"2019-01-01",
            "url":"https://ausbiz.com.au/",
            "sameAs":[
              "https://www.twitter.com/ausbiztv",
              "https://www.facebook.com/711458752615326",
              "https://www.linkedin.com/company/ausbiztv/",
              "https://www.youtube.com/@ausbizTV"
            ]
          },
          "about":  [
            {
              "@id": "${getEnv("BASE_URL")}/topic/${item.topic.name}/${item.topic.id}",
              "name": "${item.topic.name}"
            }${(about && about.length > 0) ? `,${about}` : ''}
          ],
          "contributor": [${experts}],
          "author": [${experts}]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "${getEnv("BASE_URL")}/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "${item.eventSeries ? escapeDoubleQuotes(item.eventSeries.name) : escapeDoubleQuotes(item.topic.name)}",
              "item": "${item.eventSeries ? getEnv("BASE_URL") + "/series/" + convertToSlug(item.eventSeries.name) + "?seriesID=" + item.eventSeries.id : getEnv("BASE_URL") + "/topic/" + convertToSlug(item.topic.name) + "/" + item.topic.id}"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "${item?.title ? escapeDoubleQuotes(item?.title) : ""}",
              "item": "${getEnv("BASE_URL")}/media/${convertToSlug(item?.title)}?videoId=${item.id}"
            }
          ]
        }`
      )
    });
    return structuredData.join();
  }else {
    return  null;
  }
  
};

export const formatTime = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });

  return formattedTime;
}

export const sanitizeAndProcessHtml = (htmlDesc) => {
  htmlDesc = DOMPurify.sanitize(htmlDesc)
  htmlDesc = htmlDesc.replace(/<p/g, '<p class="description" ');
  htmlDesc = htmlDesc.replace(/<a/g, '<a class="custom_links" ');
  htmlDesc = htmlDesc.replace(/<li/g, '<li class="default_listing description" ');
  htmlDesc = htmlDesc.replace(/<ul/g, '<ul class="default_listing" ');
  htmlDesc = htmlDesc.replace(/<ol/g, '<ol class="default_listing" ');
  htmlDesc = htmlDesc.replace(/<img/g, '<img class="responsive-img" ');
  return htmlDesc;
}